import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const NettoyageTerrasse = () => {
  // Initialiser Google Ads
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'AW-16912204930');
    }
  }, []);

  return (
    <div className="page-container">
      <Helmet>
        <title>Nettoyage terrasse en Île-de-France | Devis rapide</title>
        <meta
          name="description"
          content="Redonnez vie à votre terrasse en Île-de-France. Nettoyage efficace, respect des matériaux, devis rapide avec Call Garden"
        />
      </Helmet>
      <div className="page-content">
        <div className="section-header">
          <div className="section-badge">Nettoyage de terrasse</div>
          <h1 className="page-title">Nettoyage de terrasse</h1>
        </div>

        {/* Main Image Section - Two Images Side by Side */}
        <section className="modern-section" style={{padding: '0 0 clamp(2rem, 4vw, 3rem) 0'}}>
          <div style={{
            display: 'flex',
            gap: '1rem',
            width: '100%',
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 clamp(1rem, 3vw, 1.8rem)'
          }}>
            {/* Left Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/imgsection/Terrasse/IMG_6264.webp" 
                alt="Nettoyage terrasse" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
            
            {/* Right Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/imgsection/Terrasse/IMG_6265.webp" 
                alt="Terrasse nettoyée" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
          </div>
        </section>

        <div className="modern-section" style={{paddingTop: '2rem'}}>
          <div className="section-container">
            <div className="modern-card" style={{maxWidth: '900px', margin: '0 auto'}}>
              <h2 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginBottom: '1.25rem'}}>
                Redonnez une seconde vie à votre terrasse
              </h2>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                Votre terrasse a perdu de son éclat ? Bois grisé, dalles noircies, mousse qui s’installe… Avec le temps, les extérieurs se dégradent vite. Chez Call Garden, on vous aide à retrouver une terrasse propre, saine et agréable, sans risque pour vos matériaux.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                Le nettoyage de terrasse ne s’improvise pas. Chaque surface réagit différemment : bois naturel, composite, pierre, carrelage…
              </p>

              <h2 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginTop: '2.25rem', marginBottom: '1.25rem'}}>
                Nos conseils pour entretenir votre terrasse
              </h2>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                Un bon nettoyage, c’est bien. Un entretien régulier, c’est encore mieux.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                Quelques gestes simples peuvent faire la différence : balayer régulièrement pour éviter l’accumulation de saletés, éviter les produits trop agressifs, surveiller l’apparition de mousse dès les premières traces, nettoyer en douceur plutôt que de laisser s’encrasser.
              </p>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                On vous partage ces conseils directement lors de notre passage.
              </p>

              <h2 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginTop: '2.25rem', marginBottom: '1.25rem'}}>
                Pourquoi choisir Call Garden
              </h2>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '1.25rem'}}>
                On ne vient pas juste “nettoyer”. On intervient avec une vraie logique de durabilité.
              </p>
              <ul style={{margin: 0, paddingLeft: '1.25rem', marginBottom: '1.5rem'}}>
                <li>Une approche respectueuse des matériaux (pas de haute pression agressive inutile)</li>
                <li>Des produits efficaces, choisis avec attention pour votre environnement</li>
                <li>Une vraie expérience terrain dans l’entretien des extérieurs</li>
                <li>Des résultats visibles dès la première intervention</li>
                <li>Des conseils simples pour garder votre terrasse propre plus longtemps</li>
              </ul>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '0.5rem'}}>
                Votre terrasse est entre de bonnes mains, du diagnostic jusqu’à la finition.
              </p>

              <div style={{marginTop: '3rem', textAlign: 'center'}}>
                <Link to="/contact" className="modern-button">
                  <span>Demander un devis</span>
                  <svg width="20" height="20" viewBox="0 0 512 512" fill="currentColor">
                    <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NettoyageTerrasse;
